// extracted by mini-css-extract-plugin
module.exports = {"card":"AddressCard_card__28Qfc","street":"AddressCard_street__16S63","details":"AddressCard_details__1-Bq3","action":"AddressCard_action__3c9pb"};